import React from 'react';
import PropTypes from 'prop-types';

import { Alert as MUIAlert } from '@material-ui/lab';

export const Alert = props => <MUIAlert {...props} />;

Alert.propTypes = {
  action: PropTypes.node,
  children: PropTypes.node,
  classes: PropTypes.object,
  closeText: PropTypes.string,
  icon: PropTypes.node,
  iconMapping: PropTypes.object,
  onClose: PropTypes.func,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
};

export default Alert;
